import React from "react";
import { PortWidget } from "@projectstorm/react-diagrams-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";

const STYLE_BY_KIND = {
  solution: {
    border: "#2a70b5",
    bg: "#eef6ff",
    badge: "Solution",
  },
  step: {
    border: "#6c5ce7",
    bg: "#f2efff",
    badge: "Step",
  },
  group: {
    border: "#16a34a",
    bg: "#edfdf3",
    badge: "Input Group",
  },
  input: {
    border: "#64748b",
    bg: "#f8fafc",
    badge: "Input",
  },
};

const WIDTH_BY_KIND = {
  solution: 260,
  step: 260,
  group: 240,
  input: 240,
};

function NodePort({ engine, port }) {
  const alignment = String(port.getOptions().alignment || "").toLowerCase();
  const isInPort = !!port.getOptions().in;
  const position =
    alignment === "left"
      ? { left: -7, top: "50%", transform: "translateY(-50%)" }
      : alignment === "right"
      ? { right: -7, top: "50%", transform: "translateY(-50%)" }
      : isInPort
      ? { top: -7, left: "50%", transform: "translateX(-50%)" }
      : { bottom: -7, left: "50%", transform: "translateX(-50%)" };
  return (
    <div
      style={{
        position: "absolute",
        width: 14,
        height: 14,
        borderRadius: 999,
        background: "#1f2937",
        border: "2px solid #ffffff",
        ...position,
      }}
    >
      <PortWidget engine={engine} port={port}>
        <div style={{ width: 14, height: 14 }} />
      </PortWidget>
    </div>
  );
}

export default function SolutionFlowNodeWidget({ node, engine, onNodeClick }) {
  const nodeKind = node.options.nodeKind || "step";
  const visual = STYLE_BY_KIND[nodeKind] || STYLE_BY_KIND.step;
  const borderColor = node.options.color || visual.border;
  const isFlowFocused = !!node.options.isFlowFocused;
  const focusedGlowColor = "rgba(108, 92, 231, 0.55)";
  const nodeWidth = WIDTH_BY_KIND[nodeKind] || 240;
  const ports = Object.values(node.getPorts() || {});
  const flowSelection = node?.options?.flowSelection;

  return (
    <div
      data-solution-flow-node="true"
      onClick={(event) => {
        if (!flowSelection) return;
        onNodeClick?.({
          ...flowSelection,
          clientX: event.clientX,
          clientY: event.clientY,
        });
      }}
      style={{
        position: "relative",
        width: nodeWidth,
        border: `2px solid ${borderColor}`,
        background: visual.bg,
        borderRadius: 12,
        padding: "10px 12px",
        cursor: flowSelection ? "pointer" : "default",
        boxShadow: isFlowFocused
          ? `0 0 0 3px ${focusedGlowColor}, 0 0 18px ${focusedGlowColor}`
          : node.options.selected
          ? `0 0 0 3px ${borderColor}33`
          : "none",
      }}
    >
      {nodeKind === "input" && flowSelection ? (
        <button
          type="button"
          className="btn btn-sm btn-light border"
          title="Edit input"
          aria-label="Edit input"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onNodeClick?.({
              ...flowSelection,
              action: "edit",
              clientX: event.clientX,
              clientY: event.clientY,
            });
          }}
          style={{
            position: "absolute",
            top: 6,
            right: 6,
            width: 26,
            height: 26,
            padding: 0,
            zIndex: 2,
          }}
        >
          <FontAwesomeIcon icon={faPen} />
        </button>
      ) : null}
      {ports.map((port) => (
        <NodePort key={port.getID()} engine={engine} port={port} />
      ))}

      <div
        className="text-uppercase fw-bold"
        style={{ fontSize: 10, letterSpacing: "0.06em", color: borderColor }}
      >
        {visual.badge}
      </div>
      <div className="fw-bold" style={{ fontSize: 14, lineHeight: 1.2 }}>
        {node.options.title}
      </div>
      {node.options.subtitle ? (
        <div className="text-secondary" style={{ fontSize: 12 }}>
          {node.options.subtitle}
        </div>
      ) : null}
      {node.options.meta ? (
        <div className="text-secondary" style={{ fontSize: 11 }}>
          {node.options.meta}
        </div>
      ) : null}
    </div>
  );
}
